<template>
  <div class="base-table">
    <table>
      <thead>
        <slot name="header">
          <tr>
            <th v-for="column in columns" :key="column.value">
              <div class="base-table__header-cell">
                <span>
                {{ column.label }}
                </span>
                <button v-if="column.sortable" class="base-table__sort-icon" @click="sort(column.value)">
                  <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                  <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                </button>
              </div>
            </th>
          </tr>
        </slot>
      </thead>
      <tbody>
        <slot>
          <tr v-for="row in dataShow" :key="row.id" @click="rowClick(row)">
            <td v-for="column in columns" :key="`cell-${column.label}`">
              <slot :name="`cell-${column.value}`" :column="row" >
                {{ row[column.value] }}
              </slot>
            </td>
          </tr>
        </slot>
      </tbody>
    </table>
  </div>
</template>

<script>
import {firstBy} from "thenby";
import { paginateList } from '@utils/pagination.js'

export default {
  name: "BaseTable",
  props: {
    data: { type: Array, default: () => [] },
    columns: { type: Array, default: () => [] },
    currentPage: { type: Number, default: 1},
    perPage: { type: Number, default: 0},
  },
  data() {
    return {
      sortNow: {nameColumn: '', direction: 1},
      dataTable: [],
    }
  },
  computed: {
    dataShow() {
      if (this.perPage) {
        return paginateList(this.dataTable, this.currentPage, this.perPage)
      }
      return paginateList(this.dataTable, this.currentPage, this.dataTable.length)
    }
  },
  watch: {
    data(newVal) {
      this.dataTable = [...newVal]
    },
  },
  mounted() {
     this.dataTable = this.data
  },
  methods: {
    rowClick(rowData) {
      this.$emit("row-click", rowData);
    },
    sort(value) {
      if (this.sortNow.nameColumn === value && this.sortNow.direction === 1 ) {
        this.dataTable.sort(
          firstBy(value, { ignoreCase:true, direction: -1 })
        );
        this.sortNow.direction = -1;
        return
      }
      if (this.sortNow.nameColumn === value && this.sortNow.direction === -1 ) {
        this.dataTable.sort(
          firstBy(value, { ignoreCase:true, direction: 1 })
        );
        this.sortNow.direction = 1;
        return
      }
      this.dataTable.sort(
        firstBy(value, {ignoreCase:true})
      );
      this.sortNow.nameColumn = value;
      this.sortNow.direction = 1;
    }
  }
};
</script>

<style>
.base-table {
  width: 100%;
  overflow-x: auto;
  max-width: 100%;
}

.base-table table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 8px;
  border-style: hidden;
}

.base-table tr {
  height: 50px;
  cursor: pointer;
}

.base-table td,
.base-table th {
  padding: 0 15px;
}

.base-table th {
  border-collapse: collapse;
}

.base-table td {
  overflow-wrap: anywhere;
  word-break: break-word;
  border: solid 1px transparent;
  background: rgba(235, 234, 244, 0.25);
}

.base-table td:first-child {
  border-radius: 15px 0 0 15px;
}

.base-table td:last-child {
  border-radius: 0 15px 15px 0;
}

.base-table__header-cell {
  display: flex;
  align-items: center;
}

.base-table__sort-icon {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 18px;
  margin-left: 10px;
  background-color: #fff;
  border: none;
  cursor: pointer;
}
</style>
